import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'

export default class extends Controller {
  initialize () {
    this.scroll = new SmoothScroll(null, {
      offset: 55,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
  }

  scrollTo (id) {
    const anchor = document.querySelector(id)
    this.scroll.animateScroll(anchor)
  }

  scrollOrRedirectToAdmissionCondition (e) {
    const admissionConditionSection = document.getElementById('admission_condition')
    if (admissionConditionSection) {
      e.preventDefault()
      this.scrollTo('#admission_condition')
    }
  }

  scrollOrRedirectToReviews (e) {
    const reviewsSection = document.getElementById('reviews')
    if (reviewsSection) {
      this.scrollTo('#reviews')
    } else {
      window.location.href = e.target.dataset.url
    }
  }

  get className () {
    return this.element.dataset.classname
  }
}
